import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=08b31686&scoped=true"
var script = {}
import style0 from "./tile.vue?vue&type=style&index=0&id=08b31686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b31686",
  null
  
)

export default component.exports